import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { compose } from 'redux';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Create from '@material-ui/icons/Create';
import ViewList from '@material-ui/icons/ViewList';
import Help from '@material-ui/icons/Help';
import Dashboard from '@material-ui/icons/Dashboard';
import Computer from '@material-ui/icons/Computer';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import AccountCircle from '@material-ui/icons/AccountCircle';
import AccountBalance from '@material-ui/icons/AccountBalance';
import { startLogout } from '../actions/authActions';
import { version } from '../../package.json';

const styles = theme => ({
  nested: {
    paddingLeft: theme.spacing.unit * 4,
  },
});

export class NavBar extends Component {

  state = {
    adminTabOpen: false
  }

  handleClick = () => {
    this.setState({ adminTabOpen: !this.state.adminTabOpen });
  };

  render() {
    return (
      <List component="nav">
          <NavLink
            activeClassName="is-active"
            to="/dashboard"
            style={{ textDecoration: 'none', color: 'unset' }}
          >
            <ListItem button>
              <ListItemIcon>
                <Dashboard />
              </ListItemIcon>
              <ListItemText primary="Dashboard" />
            </ListItem>
          </NavLink>
        <NavLink
          activeClassName="is-active"
          to="/cashier"
          style={{ textDecoration: 'none', color: 'unset' }}
        >
          <ListItem button>
            <ListItemIcon>
              <ViewList />
            </ListItemIcon>
            <ListItemText primary="Cashier" />
          </ListItem>
        </NavLink>


        <NavLink
          activeClassName="is-active"
          to="/create"
          style={{ textDecoration: 'none', color: 'unset' }}
        >
          <ListItem button>
            <ListItemIcon>
              <Create />
            </ListItemIcon>
            <ListItemText primary="Create Entry" />
          </ListItem>
        </NavLink>
        {
          this.props.role === 'admin' ?
        (
          <span>
          <ListItem button onClick={this.handleClick}>
          <ListItemIcon>
            <AccountCircle />
          </ListItemIcon>
          <ListItemText inset primary="Admin" />
            {this.state.adminTabOpen ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={this.state.adminTabOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <NavLink
              activeClassName="is-active"
              to="/admin/add-vendors"
              style={{ textDecoration: 'none', color: 'unset' }}
            >
              <ListItem button className={this.props.classes.nested}>
                <ListItemIcon>
                  <AccountBalance />
                </ListItemIcon>
                <ListItemText inset primary="Add Vendors" />
              </ListItem>
            </NavLink>

            <NavLink
              activeClassName="is-active"
              to="/admin/edit-vendors"
              style={{ textDecoration: 'none', color: 'unset' }}
            >
              <ListItem button className={this.props.classes.nested}>
                <ListItemIcon>
                  <AccountBalance />
                </ListItemIcon>
                <ListItemText inset primary="Edit Vendors" />
              </ListItem>
            </NavLink>

            <NavLink
              activeClassName="is-active"
              to="/admin/add-expense-accounts"
              style={{ textDecoration: 'none', color: 'unset' }}
            >
              <ListItem button className={this.props.classes.nested}>
                <ListItemIcon>
                  <AccountBalance />
                </ListItemIcon>
                <ListItemText inset primary="Add Account" />
              </ListItem>
            </NavLink>

            <NavLink
              activeClassName="is-active"
              to="/admin/edit-expense-accounts"
              style={{ textDecoration: 'none', color: 'unset' }}
            >
              <ListItem button className={this.props.classes.nested}>
                <ListItemIcon>
                  <AccountBalance />
                </ListItemIcon>
                <ListItemText inset primary="Edit Account" />
              </ListItem>
            </NavLink>

          </List>
        </Collapse> </span>) : ''
        }
        <NavLink
          style={{ textDecoration: 'none', color: 'unset' }}
          activeClassName="is-active"
          to="/help"
        >
          <ListItem button>
            <ListItemIcon>
              <Help />
            </ListItemIcon>
            <ListItemText primary="Help" />
          </ListItem>
        </NavLink>
        <ListItem>
          <ListItemIcon>
            <Computer />
          </ListItemIcon>
          <ListItemText primary={`Ver: ${version}`} />
        </ListItem>
      </List>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  startLogout: () => dispatch(startLogout())
});

const mapStateToProps = ({ auth }) => {
  const { role } = auth;
  return { role }
};

export default compose(
  withStyles(styles, {
    name: 'NavBar',
}), connect(mapStateToProps, mapDispatchToProps))(NavBar);



// WEBPACK FOOTER //
// ./src/components/NavBar.js